import { path as PageActsOnSigningPath } from 'pages/PageActsOnSigning';
import { path as PageMySurveyActsPath } from 'pages/PageMySurveyActs';
import { path as PageAppIndicatorListPath } from 'pages/PageAppIndicatorList';
import { path as PageApplicationListPath } from 'pages/PageApplicationList';
import { path as PageApplicationPprListPath } from 'pages/PageApplicationPprList';
import { getPath as getAreaListPath } from 'pages/PageAreaList';
import { path as PageAreaPprListPath } from 'pages/PageAreaPprList';
import {
  biot_standards_path as PageBiotStandards,
  k2_design_standards_path as PageK2DesignStandards,
  k2_design_standard_of_finished_objects as PageK2DesignStandardsOfFinishedObjects,
  service_standards_path as PageServiceStandards,
} from 'pages/PageBIStandards';
import { path as PageCapexReportPath } from 'pages/PageCapexReport';
import { path as PageChecklistAfterIndicatorListPath } from 'pages/PageChecklistAfterIndicatorList';
import { path as PageChecklistAfterListPath } from 'pages/PageChecklistAfterList';
import { path as PageChecklistBeforeIndicatorListPath } from 'pages/PageChecklistBeforeIndicatorList';
import { path as PageChecklistRegisterPath } from 'pages/PageChecklistRegister';
import { path as PageConfluencePath } from 'pages/PageConfluence';
import { path as PageDelayApplicationReportPath } from 'pages/PageDelayApplicationReport';
import { path as PageEmployeeListPath } from 'pages/PageEmployeeList';
import { path as PageEventsPath } from 'pages/PageEvents';
import { path as PageGroupApplicationListPath } from 'pages/PageGroupApplicationList';
import { path as PageGroupApplicationReportPath } from 'pages/PageGroupApplicationReport';
import { path as PageHierarchyDiagramPath } from 'pages/PageHierarchyDiagram';
import { path as PageKPIIndicatorListPath } from 'pages/PageKPIIndicatorList';
import { path as PageKPITypeListPath } from 'pages/PageKPITypeList';
import { path as PageMoReportsListPath } from 'pages/PageMoReportsList';
import { path as PageMyApplicationListPath } from 'pages/PageMyApplicationList';
import { path as PagePurchaseApplicationListPath } from 'pages/PagePurchaseApplicationList';
import { path as PageRealEstatePath } from 'pages/PageRealEstate';
import { path as PagePersonalRegistryPath } from 'pages/PagePersonalRegistry';
import { path as PageReportsListPath } from 'pages/PageReportsList';
import { path as PageServiceOrgListPath } from 'pages/PageServiceOrgList';
import { path as PageSICDReportListPath } from 'pages/PageSICDReportList';
import { path as PageStaffListPath } from 'pages/PageStaffList';
import { path as PageTaskPprListPath } from 'pages/PageTaskPprList';
import { path as PageTaskReportPprListPath } from 'pages/PageTaskReportPprList';
import { path as PageTechMapApplicationListPath } from 'pages/PageTechMapApplicationList';
import { path as PageUserKPIListPath } from 'pages/PageUserKPIList';
import { path as PageUsoApplicationListPath } from 'pages/PageUsoApplicationList';

import { AppBarNavMenuItem } from './types';

export const APPBAR_MENU: AppBarNavMenuItem[] = [
  {
    name: 'Список заявок',
    operations: [],
    children: [
      {
        name: 'Все заявки',
        path: PageApplicationListPath,
        operations: ['APPLICATION_VIEW'],
      },
      {
        name: 'Мои заявки',
        path: PageMyApplicationListPath,
        operations: [],
      },
      {
        name: 'Групповые заявки',
        path: PageGroupApplicationListPath,
        operations: ['APPLICATION_GROUP_VIEW'],
      },
      {
        name: 'Заявки онлайн УСО',
        path: PageUsoApplicationListPath,
        operations: ['OPERATION_OBJECT_MANAGER'],
      },
      {
        name: 'Заявки планов мероприятий',
        path: PageTechMapApplicationListPath,
        operations: ['TECH_MAP_MANAGER_VIEW'],
      },
      {
        name: 'Заявки на закуп',
        path: PagePurchaseApplicationListPath,
        operations: ['APPLICATION_PURCHASE_VIEW'],
      },
      {
        name: 'Акты на подписании',
        path: PageActsOnSigningPath,
        operations: ['VIEW_CONCLUSION_ACT'],
      },
      {
        name: 'Мои акты обследования',
        path: PageMySurveyActsPath,
        // Реестр показывает только акты, где пользователь — подписант, поэтому отдельного права нет
        operations: [],
      },
    ],
  },
  {
    name: 'Чек-листы',
    operations: ['CHECKLIST_VIEW'],
    children: [],
    path: PageChecklistRegisterPath,
  },
  {
    name: 'Оргструктура',
    operations: [],
    children: [
      {
        name: 'Сотрудники',
        path: PageStaffListPath,
        operations: ['SAVE_STAFF'],
      },
      {
        name: 'Участки',
        path: getAreaListPath(),
        operations: ['VIEW_AREAS'],
      },
      {
        name: 'Список сотрудников',
        path: PageEmployeeListPath,
        operations: ['EMPLOYEE_MANAGER'],
      },
    ],
  },
  {
    name: 'Справочники',
    operations: [],
    children: [
      {
        name: 'Жилые комплексы',
        path: PageRealEstatePath,
        operations: ['VIEW_REAL_ESTATES'],
      },
      {
        name: 'Реестр персонала',
        path: PagePersonalRegistryPath,
        operations: ['PERSONAL_REGISTRY_VIEW'],
      },
      {
        name: 'Дирекции',
        path: PageServiceOrgListPath,
        operations: ['MANAGER_SERVICE_ORG'],
      },
      {
        name: 'События',
        path: PageEventsPath,
        operations: ['REAL_ESTATE_EVENT_OPERATION'],
      },
      {
        name: 'Конструктор АПП',
        path: PageAppIndicatorListPath,
        operations: ['ORK_CHECKLIST_EDIT'],
      },
      {
        name: 'Обходы по сданным объектам',
        path: PageChecklistAfterIndicatorListPath,
        operations: ['MANAGER_CHECK_LIST_AFTER_INDICATOR'],
      },
      {
        name: 'Чек-лист до передачи',
        path: PageChecklistBeforeIndicatorListPath,
        operations: ['MANAGER_CHECK_LIST_BEFORE_INDICATOR'],
      },
      {
        name: 'Иерархия должностей',
        path: PageHierarchyDiagramPath,
        operations: ['HIERARCHY_POSITION'],
      },
      {
        name: 'Стандарты BI Service',
        path: PageServiceStandards,
        operations: ['STANDARD_BI_SERVICE'],
      },
      {
        name: 'Стандарты BI K2 - стандарты проектирования',
        path: PageK2DesignStandards,
        operations: ['STANDARD_K2'],
      },
      {
        name: 'Стандарты BI K2 - ОГО',
        path: PageK2DesignStandardsOfFinishedObjects,
        operations: ['STANDARD_K2_OGO'],
      },
      {
        name: 'Стандарты БиОТ',
        path: PageBiotStandards,
        operations: ['STANDARD_BIOT'],
      },
      {
        name: 'Стандарты BI Service (Wiki)',
        path: 'https://wiki-opera.bi.group/directory/2409',
        operations: ['STANDARD_BI_SERVICE_WIKI'],
      },
      {
        name: 'Показатели KPI',
        operations: ['KPI_EDIT_INDICATOR'],
        path: PageKPIIndicatorListPath,
      },
      {
        name: 'Типы KPI',
        operations: ['KPI_EDIT_INDICATOR'],
        path: PageKPITypeListPath,
      },
      {
        name: 'Фактические показатели KPI',
        operations: ['KPI_USER_VIEW'],
        path: PageUserKPIListPath,
      },
    ],
  },
  {
    name: 'Книга Знаний Сервиса',
    path: PageConfluencePath,
    operations: ['CONFLUENCE_VIEW'],
    children: [],
  },
  {
    name: 'Отчеты',
    operations: [],
    children: [
      {
        name: 'Отчеты',
        path: PageReportsListPath,
        operations: ['VIEW_REPORTS'],
      },
      {
        name: 'Отчет по заявкам Capex',
        operations: ['CAPEX_VIEW'],
        path: PageCapexReportPath,
      },
      {
        name: 'Отчет по отчетам МО',
        path: PageMoReportsListPath,
        operations: ['VIEW_REPORTS_MO'],
      },
      {
        name: 'Отчет по ОВКС',
        path: PageSICDReportListPath,
        operations: ['OVKS_VIEW'],
      },
      {
        name: 'Отчет по Групповым заявкам',
        path: PageGroupApplicationReportPath,
        operations: ['APPLICATION_GROUP_REPORT_VIEW'],
      },
      {
        name: 'Отчет по просроченным заявкам',
        path: PageDelayApplicationReportPath,
        operations: ['APPLICATION_DELAY_REPORT_VIEW'],
      },
      {
        name: 'Отчет по Регулировке Окон',
        path: PageChecklistAfterListPath,
        operations: ['CHECK_LIST_AFTER_MANGER'],
      },
    ],
  },
  {
    name: 'ППР',
    operations: [],
    children: [
      {
        name: 'Объекты',
        path: PageAreaPprListPath,
        operations: ['PPR_OBJECT'],
      },
      {
        name: 'Задачи',
        path: PageTaskPprListPath,
        operations: ['PPR_TASK_VIEW'],
      },
      {
        name: 'Заявки',
        path: PageApplicationPprListPath,
        operations: ['PPR_APPLICATION_VIEW'],
      },
      {
        name: 'Отчет по задачам ППР/ЕТО',
        path: PageTaskReportPprListPath,
        operations: ['PPR_TASK_REPORT_VIEW'],
      },
    ],
  },
];
